import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDistinctUniversSelector } from 'store/user/selectors';
import { renderPath } from 'utils/string';
import { IconBlock } from 'containers/NavBarDashboard/styles';
import { isReverse } from 'helpers/intl';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { setSignupStep } from 'store/user/actions';
import { PERSONAL_INFO } from 'containers/SignupPages/constants';

const Logo = () => {
  const univers = useSelector(getDistinctUniversSelector);
  const token = localStorage.getItem('token');
  const link = univers.length === 1 ? renderPath(univers[0]) : PAGES.LOGIN;
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const dispatch = useDispatch();

  return (
    <IconBlock
      isClickable
      alt="logo-icon"
      data-testid="logo"
      src={AssuranceIcon[reverse ? 'sahamAr' : 'saham']}
      onClick={() =>
        token
          ? link && pushTo(link)
          : dispatch(setSignupStep(PERSONAL_INFO)) && pushTo(PAGES.LOGIN)
      }
    />
  );
};

export default Logo;
